<template>
  <div
    class="h-full overflow-hidden"
    element-loading-background="rgba(0, 0, 0, 0.5)"
  >
    <div class="flex items-center justify-between mt-10px mb-10px">
      <categoryTitle title="最新报警信息" />
      <!-- <el-switch
        v-model="flashSwitch"
        active-color="#18bdd4"
        inactive-color="#d2d4d7"
        @change="handleFlashSwitch"
        v-if="alarmList.length > 0"
      /> -->
    </div>
    <div class="h-180px overflow-hidden" v-loading="tableLoading">
      <InfiniteScroll
        :deviation="10"
        direction="Y"
        :limit="1"
        :num="alarmList.length"
        :speed="0.5"
        ref="infiniteScrollRef"
        @reset="resetScrollHeight"
        v-if="alarmList.length"
      >
        <div>
          <div
            :class="['border-1px border-[#0e7a84] rounded-4px mb-5px p-5px text-[#e84e4e]', { 'alarm-flash': alarmList.length > 0 && flashSwitch }]"
            v-for="(item, index) in alarmList"
            :key="index"
          >
            <div class="mb-4px">{{ item.alarmTypeName }} {{item.fenceName  }}</div>
            <div class="text-12px">{{ dayjs(item.eventStartTime).format('YYYY-MM-DD HH:mm:ss') }}</div>
          </div>
        </div>
      </InfiniteScroll>
    </div>
    <categoryTitle class="mt-10px mb-10px" title="人员定位" />
    <div class="mb-10px flex items-center">
      <el-select v-model="searchStatus" popper-class="visualization-select-popper">
        <el-option label="在线" value="0"></el-option>
        <el-option label="离线" value="1"></el-option>
      </el-select>
      <el-input
        placeholder="请输入关键字"
        v-model="personnelKeyword"
        @keypress.enter.native="filterPersonData"
        clearable
      >
        <i
          class="el-input__icon el-icon-search cursor-pointer"
          slot="suffix"
          @click="filterPersonData"
        ></i>
      </el-input>
    </div>
    <el-table
      :data="personTable"
      height="calc(100% - 250px)"
      highlight-current-row
      v-loading="personPosLoading"
    >
      <el-table-column label="姓名" prop="personnelName"></el-table-column>
      <el-table-column label="部门" prop="departmentName"></el-table-column>
      <el-table-column label="操作" width="120px">
        <template slot-scope="{ row }">
          <div class="flex">
            <div
              class="flex items-center mr-15px cursor-pointer"
              @click="goLocation(row)"
              v-if="searchStatus === '0'"
            >
              <div class="h-14px w-15px location-icon mr-5px"></div>
              <span>定位</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import categoryTitle from '@/components/cockpit/CategoryTitle'
import { StandardAlarmRecordApi, TagApi } from '@wiz-api/personnel-position'
import {
  includes,
  filter,
  find,
  cloneDeep,
} from 'lodash'
import InfiniteScroll from '../components/InfiniteScroll'
import personnelList from '../../../assets/js/componentMethods/personnelList'

const standardAlarmRecordApi = new StandardAlarmRecordApi()
const tagApi = new TagApi()
export default {
  name: 'FuxianPersonList',
  components: {
    categoryTitle,
    InfiniteScroll
  },
  props: {
    cloudRender: {
      type: Object,
      default: () => {},
    },
    /** 场景id */
    sourceId: {
      type: String,
      defalut: '',
    },
    labelList: {
      type: Array,
      default: () => {
        return []
      },
    },
    onlineTagList: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      alarmList: [],
      tableLoading: false,
      // 人员动态
      personnelKeyword: '',
      searchStatus: '0',
      personPosLoading: false,
      personTable: [],
      allPerson: [],
      isHistoricalTrajectory: false,
      isCreating: false,
      isCurrentId: '',
      flashSwitch: true, // 闪烁开关默认开启
    }
  },
  watch: {
    searchStatus() {
      this.filterPersonData()
    },
    onlineTagList() {
      console.log('onlineTagList 111', this.onlineTagList)
      this.personPosLoading = true
      if (this.searchStatus === '0') {
        this.personTable = this.dealUserTree(cloneDeep(this.allPerson), true)
      }
      this.$nextTick(() => { return (this.personPosLoading = false) })
    },
  },
  methods: {
    resetScrollHeight() {
      this.$refs.infiniteScrollRef.height = 0
    },
    handleFlashSwitch(value) {
      // 处理闪烁开关变化
      console.log('闪烁开关状态:', value)
    },
    async getAlarmList() {
      // this.tableLoading = true
      const [err, res] = await standardAlarmRecordApi.getList({
        skipCount: 0,
        maxResultCount: 10
      })
      if (!err) {
        this.alarmList = res.items
      }
      // this.tableLoading = false
    },
    filterPersonData() {
      this.personPosLoading = true
      console.log('filterPersonData')
      const list = this.dealUserTree(cloneDeep(this.allPerson), this.searchStatus === '0')
      if (this.personnelKeyword) {
        this.personTable = list.filter((item) => {
          return includes(item.personnelName, this.personnelKeyword)
        })
      } else {
        this.personTable = list
      }
      this.personPosLoading = false
    },
    // 获取人员动态数据
    async getPersonnelList() {
      this.personPosLoading = true
      const [err, res] = await tagApi.getTagList({
        skipCount: 0,
        maxResultCount: 9999,
      })
      if (!err && res.items) {
        const list = res.items.filter((item) => {
          return item.personnelId && item.personnelName && item.type === 2
        })
        this.allPerson = list
        this.personTable = this.dealUserTree(cloneDeep(this.allPerson), this.searchStatus === '0')
      }
      this.personPosLoading = false
    },
    // 筛选人员
    dealUserTree(allPerson, isFilterOnline = true) {
      console.log('dealUserTree', allPerson, isFilterOnline)
      let result = []
      if (isFilterOnline) {
        result = filter(allPerson, (item) => {
          return find(this.onlineTagList, (it) => { return it === item.tagCode })
        })
      } else {
        result = filter(allPerson, (item) => {
          return !find(this.onlineTagList, (it) => { return it === item.tagCode })
        })
      }
      return result
    },
    // 人员动态定位
    goLocation(data) {
      console.log('goLocation', data)
      // 如果正在查看历史轨迹，提示退出
      if (this.isHistoricalTrajectory) {
        return this.$message.warning({
          showClose: true,
          message: '请先退出轨迹回放',
        })
      }
      const label = find(this.labelList, ['code', 'PersonnelList'])
      if (!label.checked) {
        this.$message.warning({
          showClose: true,
          message: '没有勾选人员标签，请先勾选',
        })
        return
      }
      personnelList.openPersonnelDetail(data.personnelId, data.tagCode)
    },
    // 人员动态路线
    goRoute(data) {
      if (this.isCurrentId === data.personnelId) return
      if (this.isCreating) {
        return this.$message.warning({
          showClose: true,
          message: '上一个人员数据未加载完，请稍后',
        })
      }
      this.isCreating = true
      this.isCurrentId = data.personnelId
      this.$emit('operateTrajectory', {
        visible: true,
        personnelId: data.personnelId,
        tagCode: data.tagCode,
      })
    },
    handleDispatch(event, detail) {
      const handleEvent = new CustomEvent(event, {
        detail,
      })
      window.dispatchEvent(handleEvent)
    },
  },
  async created() {
    this.getAlarmList()
    await this.getPersonnelList()
    this.handleDispatch('setLabelChecked', {
      code: 'PersonnelList',
      checked: true,
    })
    this.alarmInterval = setInterval(() => {
      this.getAlarmList()
    }, 10 * 1000)
  },
  beforeDestroy() {
    this.handleDispatch('setLabelChecked', {
      code: 'PersonnelList',
      checked: false,
    })
    clearInterval(this.alarmInterval)
  },
}
</script>

<style lang="scss" scoped>
.location-icon {
  background: url('../../../assets/images/control/location.png');
  background-size: 100% 100%;
}

// 报警红闪烁动画
@keyframes alarmFlash {
  0% {
    background-color: transparent;
    border-color: #0e7a84;
  }

  50% {
    background-color: rgba(255, 73, 73, 0.1);
    border-color: #ff4949;
  }

  100% {
    background-color: transparent;
    border-color: #0e7a84;
  }
}

.alarm-flash {
  animation: alarmFlash 1s infinite;
}
</style>
